import React, { useEffect, useState } from "react";
import { SetPermission } from "app/Components/SetPermission/Permissions";
import MainBreadcrumb from "app/views/custom/components/MainBreadcrumb";
import { Col, Row } from "react-bootstrap";
import { FaRegEdit } from "react-icons/fa";
import { FiSettings } from "react-icons/fi";
import { MdHistory } from "react-icons/md";
import { HiOutlineDocumentReport } from "react-icons/hi";
import { AiOutlineSchedule, AiOutlineFileSearch } from "react-icons/ai";
import { GoReport, GoStop } from "react-icons/go";
// import { TbReport, TbReportSearch } from "react-icons/tb";
import { CgCalendarDates } from "react-icons/cg";
import { Link } from "react-router-dom";
import { getVFL } from "app/_services/ehs/VFLService";
import {
  isUserMM,
  isUserSO,
  isUserVFLOfficer,
  IS_USER_SITE_HO,
  LOGGED_IN_USER_SITE_ID,
  LOGGED_USER_ID,
} from "../IncidentManagement/Helper";
import { ACTIVE_MODULE, SITE_TYPE } from "app/_constants/constant";
import { VFL_STATUS } from "./CONSTANTS";

function VFL() {
  const [VFLList, setVFLList] = useState([]);
  const [countObj, setCountObj] = useState({});

  useEffect(() => {
    getVflList();
  }, []);

  const getVflList = () => {
    getVFL().then((response) => {
      if (!response?.status) return;

      setVFLList(response.data);
    });
  };

  useEffect(() => {
    let assigned = 0;
    let result = VFLList.filter((row) => {
      let flag = false;
      // if (row.vflStatus) {
      //   if (
      //     row.vflStatus === "scheduled" &&
      //     isUserMM() &&
      //     ((row.vflAssignerSiteType === SITE_TYPE.ho && IS_USER_SITE_HO()) ||
      //       (row.vflAssignerSiteType === SITE_TYPE.mines &&
      //         LOGGED_IN_USER_SITE_ID() === row.mineId))
      //   ) {
      //     flag = true;
      //   } else if (
      //     [VFL_STATUS.assigned, VFL_STATUS.executed, VFL_STATUS.overdue].includes(
      //       row.vflStatus
      //     ) &&
      //     isUserVFLOfficer() &&
      //     LOGGED_USER_ID() === row.vflExecutiveId
      //   ) {
      //     flag = true;
      //     assigned++;
      //   } else if (
      //     row.vflStatus === VFL_STATUS.capaCompleted &&
      //     isUserSO() &&
      //     ((row.vflAssignerSiteType === SITE_TYPE.ho && IS_USER_SITE_HO()) ||
      //       (row.vflAssignerSiteType === SITE_TYPE.mines &&
      //         LOGGED_IN_USER_SITE_ID() === row.mineId))
      //   ) {
      //     flag = true;
      //   } else if (
      //     row.vflStatus === VFL_STATUS.capaReviewed &&
      //     isUserMM() &&
      //     ((row.vflAssignerSiteType === SITE_TYPE.ho && IS_USER_SITE_HO()) ||
      //       (row.vflAssignerSiteType === SITE_TYPE.mines &&
      //         LOGGED_IN_USER_SITE_ID() === row.mineId))
      //   ) {
      //     flag = true;
      //   } else if (
      //     (row.vflStatus === VFL_STATUS.draft || row.vflStatus === VFL_STATUS.rejected) &&
      //     isUserSO() &&
      //     ((row.vflAssignerSiteType === SITE_TYPE.ho && IS_USER_SITE_HO()) ||
      //       (row.vflAssignerSiteType === SITE_TYPE.mines &&
      //         LOGGED_IN_USER_SITE_ID() === row.mineId))
      //   ) {
      //     flag = true;
      //   }
      // }

      if (row.vflStatus) {
        if (
          row.vflStatus === "scheduled" &&
          !row?.executiveReturn &&
          isUserMM() &&
          ((row.vflAssignerSiteType === SITE_TYPE.ho && IS_USER_SITE_HO()) ||
            (row.vflAssignerSiteType === SITE_TYPE.mines &&
              LOGGED_IN_USER_SITE_ID() === row.mineId))
        ) {
          flag = true;
        } else if (
          [VFL_STATUS.assigned, VFL_STATUS.executed, VFL_STATUS.overdue].includes(
            row.vflStatus
          ) &&
          isUserVFLOfficer() &&
          LOGGED_USER_ID() === row.vflExecutiveId
        ) {
          flag = false;
          assigned++;
        } else if (
          row.vflStatus === VFL_STATUS.capaCompleted &&
          isUserSO() &&
          ((row.vflAssignerSiteType === SITE_TYPE.ho && IS_USER_SITE_HO()) ||
            (row.vflAssignerSiteType === SITE_TYPE.mines &&
              LOGGED_IN_USER_SITE_ID() === row.mineId))
        ) {
          flag = true;
        } else if (
          row.vflStatus === VFL_STATUS.capaReviewed &&
          isUserMM() &&
          ((row.vflAssignerSiteType === SITE_TYPE.ho && IS_USER_SITE_HO()) ||
            (row.vflAssignerSiteType === SITE_TYPE.mines &&
              LOGGED_IN_USER_SITE_ID() === row.mineId))
        ) {
          flag = true;
        } else if (
          (row.vflStatus === VFL_STATUS.draft || row.vflStatus === VFL_STATUS.rejected) &&
          isUserSO() &&
          ((row.vflAssignerSiteType === SITE_TYPE.ho && IS_USER_SITE_HO()) ||
            (row.vflAssignerSiteType === SITE_TYPE.mines &&
              LOGGED_IN_USER_SITE_ID() === row.mineId))
        ) {
          flag = true;
        } else if (
          row.vflStatus === VFL_STATUS.scheduled &&
          row?.executiveReturn &&
          isUserSO() &&
          ((row.vflAssignerSiteType === SITE_TYPE.ho && IS_USER_SITE_HO()) ||
            (row.vflAssignerSiteType === SITE_TYPE.mines &&
              LOGGED_IN_USER_SITE_ID() === row.mineId))
        ) {
          flag = true;
        }
      }

      return flag;
    });

    setCountObj({
      workflow: result.length,
      assigned,
    });
  }, [VFLList]);

  return (
    <div>
      <MainBreadcrumb
        routeSegments={[
          {
            name: "Health Safety And Environment",
            path: "#",
          },
          {
            name: "Visible Felt Leadership",
          },
        ]}
        module={ACTIVE_MODULE.vfl}
      />

      <div className="manageBtnScreen">
        <Row>
          <SetPermission
            permission={["safetyOfficer", "headSafety"]}
            data={
              <Col lg={4}>
                <Link
                  to={"/health-safety-and-environment/vfl/schedule"}
                  className="btn manage-btn"
                >
                  <AiOutlineSchedule />
                  Schedule VFL
                </Link>
              </Col>
            }
          />

          <SetPermission
            permission={"safetyOfficer"}
            data={
              <Col lg={4}>
                <Link
                  to={"/health-safety-and-environment/vfl/my"}
                  className="btn manage-btn"
                >
                  <GoReport />
                  My VFLs
                </Link>
              </Col>
            }
          />

          <Col lg={4} className="mb-4">
            <Link
              to={"/health-safety-and-environment/vfl/manage"}
              className="btn manage-btn"
            >
              <HiOutlineDocumentReport />
              View VFLs
            </Link>
          </Col>

          <SetPermission
            permission={["safetyOfficer", "minesManager", "vflOfficer"]}
            data={
              <>
                <Col lg={4}>
                  <Link
                    to={"/health-safety-and-environment/vfl/my-approval-incidents"}
                    className="d-block btn manage-btn approvalActionBtn"
                  >
                    <GoStop />
                    <span>My Approval Actions</span>

                    <span className="tabText">
                      {" "}
                      {countObj?.workflow > 100
                        ? ""
                        : countObj?.workflow > 10
                        ? "0"
                        : "00"}
                      {countObj?.workflow}
                      &nbsp;Workflow actions Due
                    </span>

                    {isUserVFLOfficer() && (
                      <span className="tabText">
                        {countObj?.assigned > 10 ? "" : "0"}
                        {countObj?.assigned} VFLs Assigned
                      </span>
                    )}
                  </Link>
                </Col>

                <Col lg={4}>
                  <Link
                    to={
                      "/health-safety-and-environment/vfl/my-approval-history-incidents"
                    }
                    className="btn manage-btn"
                  >
                    <AiOutlineFileSearch />
                    My Approval History
                  </Link>
                </Col>
              </>
            }
          />

          <SetPermission
            permission={["safetyOfficer", "minesManager", "vflOfficer"]}
            data={
              <Col lg={4}>
                <Link
                  to={"/health-safety-and-environment/vfl/calendar"}
                  className="btn manage-btn"
                >
                  <CgCalendarDates />
                  Calendar
                </Link>
              </Col>
            }
          />
        </Row>
        {/* <ShowActiveModules module={ACTIVE_MODULE.vfl} /> */}
      </div>
    </div>
  );
}

export default VFL;
